module.exports = __webpack_public_path__ + "img/LiteSpeed.fee4951.svg";